import { VehicleProductYearType } from '@/common/queries/selections/vehicleProductYear/vehicleProductYear.type';
import { fetchApi } from '@/config/axiosSetting';

export const getVehicleProductYearFunction = (): Promise<
  VehicleProductYearType[]
> => {
  return fetchApi.get('/selection_item/manufacturing_year/wop_list/');
};
